import React from "react";
import { Icon, Title, Spacing } from "@sicredi/react";
import styles from "./styles.module.scss";
import { ICardTracking } from "./model";
import iconAlertYellow from "../../../assets/iconAlertYellow.png";

export const CardTracking: React.FC<ICardTracking> = ({
  title,
  children,
  state,
  isIconWarning,
  isIconClock,
  isIconExclamationBlue,
}) => {
  const iconName = state ? "check" : "feedback-info";
  const colorIconBackGround = state ? "#A0DC8C" : "#B4EBFF";

  const iconClock = "clock";
  const colorIconClock = "#E1E6E1";

  return (
    <div className={styles.container}>
      <div className={styles.icon_line}>
        <div className={styles.icon_circle}>
          {isIconClock && !isIconExclamationBlue && (
            <>
              <Icon
                name={"circle-filled"}
                className={styles.icon_circle_filled}
                style={{ color: colorIconClock }}
              />
              <Icon
                name={iconClock}
                className={state ? styles.icon_done : styles.icon_waiting}
              />
            </>
          )}
          {isIconWarning && !isIconClock && !isIconExclamationBlue && (
            <>
              <img
                className={styles.img}
                src={iconAlertYellow}
                alt={"Imagem alerta"}
              />
            </>
          )}
          {!isIconWarning && !isIconClock && !isIconExclamationBlue && (
            <>
              <Icon
                name={"circle-filled"}
                className={styles.icon_circle_filled}
                style={{ color: colorIconBackGround }}
              />
              <Icon
                name={iconName}
                className={!state ? styles.icon_waiting : styles.icon_done}
              />
            </>
          )}

          {isIconExclamationBlue && (
            <>
              <Icon
                name={"circle-filled"}
                className={styles.icon_circle_filled}
                style={{ color: colorIconBackGround }}
              />
              <Icon
                name={iconName}
                className={!state ? styles.icon_waiting : styles.icon_done}
              />
            </>
          )}
        </div>

        <div className={state ? styles.line_green : styles.line_green_false} />
      </div>

      <div className={styles.title_children}>
        <Title
          className={
            isIconClock ? styles.color_title_children_false : undefined
          }
          as="h4"
          size={"large"}
          weight={state ? "normal" : "semi-bold"}
        >
          {title}
        </Title>
        {state || !state ? <>{children} </> : <Spacing appearance="medium" />}
      </div>
    </div>
  );
};
